import { render, staticRenderFns } from "./jala-sale-additional-item-table.vue?vue&type=template&id=191de1e0&scoped=true&"
import script from "./jala-sale-additional-item-table.vue?vue&type=script&lang=js&"
export * from "./jala-sale-additional-item-table.vue?vue&type=script&lang=js&"
import style0 from "./jala-sale-additional-item-table.vue?vue&type=style&index=0&id=191de1e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191de1e0",
  null
  
)

export default component.exports